// extracted by mini-css-extract-plugin
export default {"second":"Second_second__P2fcJ","second__header":"Second_second__header__wYSF-","second__title":"Second_second__title__5d+zX"};